import type {
  DeviceChangeActivity,
  Event as UserEvent,
} from "@tandemdiabetes/sugarmate-api-react-client"
import {
  DataSource,
  DeviceType,
} from "@tandemdiabetes/sugarmate-api-react-client"
import type {
  ComponentPropsWithoutRef,
  Ref,
} from "react"
import {
  forwardRef,
  useMemo,
} from "react"
import { usePolyglot } from "src/contexts"

interface Props extends ComponentPropsWithoutRef<"div"> {
  activity: DeviceChangeActivity;
  source?: UserEvent["source"];
}

export const DeviceChangeActivityTitle = forwardRef<HTMLDivElement, Props>(
  function DeviceChangeActivityTitle(props: Props, ref: Ref<HTMLDivElement>) {
    const {
      activity,
      source,
      ...htmlDivProps
    } = props

    const polyglot = usePolyglot()

    const deviceType = activity.device_type

    const deviceTypeString: string | null = useMemo(
      () => {
        if (deviceType === DeviceType.NotProvided) {
          return null
        }

        if (
          source === DataSource.Tandem &&
          deviceType === DeviceType.PumpCartridge
        ) {
          return polyglot.t("device_type.pump_cartridge_tandem")
        }

        return polyglot.t(`device_type.${deviceType}`)
      },
      [
        deviceType,
        polyglot,
        source,
      ],
    )

    if (!deviceTypeString) {
      return null
    }

    return (
      <div
        {...htmlDivProps}
        ref={ref}
      >
        {polyglot.t(
          "components.activity_summary.title.device_change",
          { device_type: deviceTypeString },
        )}
      </div>
    )
  },
)
